import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import Logo from "../assets/logo-paud.png";

function NavigationBar() {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path ? "nav-active" : "";

  return (
    <Navbar
      expand="lg"
      className="navbar-pro shadow-sm sticky-top"
      style={{ backdropFilter: "blur(12px)", zIndex: 9999 }}
    >
      <Container>

        {/* LOGO + NAMA INSTITUSI */}
        <Navbar.Brand
          as={Link}
          to="/"
          className="d-flex align-items-center gap-2"
        >
          <img
            src={Logo} 
            alt="Logo PAUD"
            style={{
              width: "38px",
              height: "38px",
              objectFit: "contain",
              animation: "pulseLogo 2.5s infinite"
            }}
          />
          <span style={{ fontWeight: "700", letterSpacing: "0.5px" }}>
            PAUD KB CAHAYA PIRADITA KANING 
          </span>
        </Navbar.Brand>

        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className={isActive("/")}>Beranda</Nav.Link>
            <Nav.Link as={Link} to="/tentang" className={isActive("/tentang")}>Tentang</Nav.Link>
            <Nav.Link as={Link} to="/visi-misi" className={isActive("/visi-misi")}>Visi & Misi</Nav.Link>
            <Nav.Link as={Link} to="/program" className={isActive("/program")}>Program</Nav.Link>
            <Nav.Link as={Link} to="/galeri" className={isActive("/galeri")}>Galeri</Nav.Link>
            <Nav.Link as={Link} to="/kontak" className={isActive("/kontak")}>Kontak</Nav.Link>
            <Nav.Link as={Link} to="/admin/login">Admin</Nav.Link>
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}

export default NavigationBar;